import React from 'react';
import { BrikCreationCardProps } from './types';
import useStyles from './styles';

export const BrikCreationCard: React.FC<BrikCreationCardProps> = ({ title, image, description, onPress, dataCy, dataCyTitle }) => {
  const styles = useStyles();
  return (
    <div
      className={styles.contentItem}
      onClick={onPress}
      data-cy={dataCy}
    >
      <div className={styles.bgImage}>
        <img style={{ width: 64, height: 64 }} src={image} alt='' />
      </div>
      
      <div className={styles.textItem}>
        <span className={styles.textName} data-cy={dataCyTitle}>{title}</span>
        <span className={styles.textDescription}>
          {description}
        </span>
      </div>
    </div>
  )
}